export enum PortalEvents {
    locationSearch = 'portal.locationSearch',
    SearchStarted = 'portal.searchStarted'
}
